"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _eventemitter = _interopRequireDefault(require("eventemitter3"));
//
// Singleton EventEmitter instance to track manifest events.
//
const events = new _eventemitter.default();
var _default = events;
exports.default = _default;